import lazyLoading from "./lazyLoading";

export default {
  name: "import",
  path: "/import",
  component: lazyLoading("excel/Import"),
  meta: {
    default: false,
    title: "Import",
    class: "info",
    show: true,
    iconClass: "glyphicon glyphicon-import",
    requiredAuth: true
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/excel.js